import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface StopTimeIconProps {
  color?: string;
  altColor?: string;
  style?: React.CSSProperties;
}

export const StopTimeIcon = ({
  color = RoutalPalette.neutral02,
  altColor = RoutalPalette.neutral40,
  style = {},
  ...props
}: StopTimeIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 17 17" style={{ width: `17px`, height: `17px`, fill: `none`, ...style }}>
      <path
        d="M14.1389 4.60743L14.2552 4.84555C14.486 5.39314 14.6002 5.95858 14.6002 6.54002C14.6002 8.54329 13.6394 10.8256 11.7238 13.1322C10.9512 14.0609 10.1714 14.8194 9.58441 15.3458C9.29128 15.6086 9.04717 15.8127 8.87737 15.9503C8.79249 16.0191 8.72624 16.0713 8.6818 16.1058C8.65958 16.123 8.64282 16.1358 8.63192 16.1441L8.62804 16.1471C8.58916 16.1721 8.56633 16.1816 8.55409 16.1857C8.54319 16.1893 8.53098 16.192 8.5082 16.192C8.46139 16.192 8.43078 16.1805 8.41183 16.1685L8.35468 16.1241C6.94137 14.9836 5.91752 13.8583 5.29935 13.1228C3.34436 10.7844 2.4082 8.56653 2.4082 6.53202C2.4082 5.19792 3.01971 3.92373 4.16118 2.944C5.31147 1.96357 6.84962 1.41602 8.5002 1.41602C9.3165 1.41602 10.1076 1.5507 10.8603 1.81899L10.8603 1.819L10.863 1.81994C11.6075 2.0805 12.2719 2.45801 12.8376 2.9426C13.3992 3.43054 13.8353 3.98571 14.1389 4.60743ZM8.05463 9.47043L8.5082 10.4481L8.96177 9.47043L9.32145 8.69512C9.3215 8.69501 9.32155 8.69491 9.3216 8.6948C9.54366 8.21824 9.93703 7.82473 10.4208 7.6024C10.4209 7.60239 10.4209 7.60237 10.421 7.60235L11.2049 7.2424L12.1944 6.78802L11.2049 6.33363L10.421 5.97368C10.4209 5.97366 10.4209 5.97365 10.4208 5.97363C9.93709 5.75133 9.54375 5.35789 9.32168 4.8814C9.32161 4.88124 9.32153 4.88108 9.32145 4.88091L8.96177 4.1056L8.5082 3.12791L8.05463 4.1056L7.69495 4.88091C7.69489 4.88106 7.69482 4.88121 7.69475 4.88135C7.47267 5.3579 7.07928 5.75138 6.59545 5.97368L5.81156 6.33363L4.82201 6.78802L5.81156 7.2424L6.59545 7.60235C7.07925 7.82464 7.47261 8.21808 7.6947 8.69458C7.69479 8.69476 7.69487 8.69494 7.69495 8.69512L8.05463 9.47043Z"
        fill={color}
        stroke={color}
      />
      <circle cx="8.50391" cy="7.43164" r="3.81055" fill={color} />
      <path d="M8.5 4.68945V8.80374L11.2429 10.1752" stroke={altColor} strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
};
